module.exports = __webpack_public_path__ + "assets/fd4cc07ab51b2ba47ff3b6dc08923236.png";